import React, { Component, Fragment } from 'react';

// Externals
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles, withWidth } from '@material-ui/core';

// Component styles
import styles from './styles';

class FullPage extends Component {
    render() {
        const { children } = this.props;
    
        return (
            <Fragment>
                {children}
            </Fragment>
        );
    };
}

FullPage.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    //classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired
};

export default compose( withStyles(styles), withWidth() )(FullPage);